module.exports = __webpack_public_path__ + "static/media/Schritt_2_Austausch_mit_der_Kollegin.5a1e93c8.pdf";